import { Menu } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  height: 100%;
  border-right: 0;
  background: inherit;
`;
